export function createBatches<T>(data: T[], batchSize: number): T[][] {
  if (batchSize < 0) {
    throw new Error('Batch size must be greater than 0');
  }

  if (batchSize === 0) return [data];
  if (data.length === 0) return [];

  const batches: T[][] = [];
  for (let i = 0; i < data.length; i += batchSize) {
    batches.push(data.slice(i, i + batchSize));
  }
  return batches;
}
